module.exports = __webpack_public_path__ + "static/media/lock-final.ecff5304.svg";